import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { DialogOptionModel } from '../../Models/DialogOptionModel';
import GenericPropertyInputRefContent from './DialogInputContent';
import { DialogInputDialog } from './DialogInputDialog';

type DialogInputProps = {
	dialog: DialogOptionModel | undefined;
	onDialogChange: (dialog: DialogOptionModel | undefined) => void;
	isEditable?: boolean;
};

export default function DialogInput({ dialog, onDialogChange, isEditable = true }: DialogInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show summary
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={dialog} />;
	}

	return (
		<GenericPropertyInput value={dialog} onValueChange={onDialogChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={dialog} />
			{open && <DialogInputDialog open={open} setOpen={setOpen} dialog={dialog} onDialogChange={onDialogChange} />}
		</GenericPropertyInput>
	);
}
